import { render, staticRenderFns } from "./editCompany.vue?vue&type=template&id=4f01b12c&scoped=true&"
import script from "./editCompany.vue?vue&type=script&lang=js&"
export * from "./editCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f01b12c",
  null
  
)

export default component.exports